import {
    Button, DialogActions, DialogContent
} from '@mui/material';
import { Datepicker } from 'components/Datepicker/Datepicker';
import PropTypes from 'prop-types';
import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { translate } from 'utils/helpers';
import { ModalHeader } from './ModalHeader';

export const UpdateInterventionDateModal = ({
                                                onClose, onConfirm, closeOnSubmit
                                            }) => {
    const { control, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {
            date: new Date()
        }
    });
    const onSubmit = (data) => {
        onConfirm(data.date);

        if (closeOnSubmit) {
            onClose();
        }
    };

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <ModalHeader onClose={onClose}>
          {translate('modalUpdateInterventionDate.title')}
        </ModalHeader>

        <DialogContent style={{ minWidth: '600px', padding: '10px' }}>
          <Controller
                    control={control}
                    name="date"
                    render={({ field: { onChange, value } }) => (
                      <Datepicker
                            error={errors.date && errors.date !== null}
                            label="common.interventionDate"
                            name="date"
                            required
                            value={value}
                            onChange={onChange}
                        />
                    )}
                    rules={{ required: true }}
                />
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>{translate('button.cancel')}</Button>
          <Button color="primary" type="submit">{translate('button.save')}</Button>
        </DialogActions>
      </form>
    );
};

UpdateInterventionDateModal.propTypes = {
    closeOnSubmit: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired
};

UpdateInterventionDateModal.defaultProps = {
    closeOnSubmit: true
};
